<template>
  <router-view></router-view>
</template>

<script>
 export default {
  name: 'App',
  components: {
  },
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  font-weight: 400;
  line-height: 1.43;
  letter-spacing: 0.01071em;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 0.875rem;

}
</style>